export default __webpack_public_path__ + "4c46ac0f5d9576d92307f5a2213feb7d.png";